<script>
  import { onMount } from 'svelte';
  import loader from '@beyonk/async-script-loader';

  export let properties;
  export let configurations = {};
  export let enabled = true;
  export let scriptScheme = 'https://';
  export let path = location.pathname;
  export let params = {};

  const GA_LOCAL_STORAGE_KEY = 'ga:clientId';

  onMount(() => {
    if (!enabled) return;
    init();
  })

  export function init() {
    window['ga'] = window['ga'] || function() {
      (window['ga'].q = window['ga'].q || []).push(arguments);
    };
    window['ga'].l = window['ga'].l || 1 * new Date();
    loader([
      {
        type: 'script',
        url: `${scriptScheme}www.google-analytics.com/analytics.js`
      }
    ], test, callback);
  }

  function test () {
    return window.ga && Array.isArray(window.ga.q);
  }

  function callback () {
    properties.forEach(p => {
      let config = configurations[p] || {};
      config['storage'] = 'none';
      config['clientId'] = localStorage.getItem(GA_LOCAL_STORAGE_KEY);
      ga('create', p, config);
      ga(function (tracker) {
        localStorage.setItem(GA_LOCAL_STORAGE_KEY, tracker.get('clientId'));
      });
      ga('set', 'checkProtocolTask', function () { /* nothing */ });
      let page = path;
      if (params) {
        page = `${path}?${new URLSearchParams(params).toString()}`;
      }
      ga('set', 'page', page);
      ga('send', 'pageview');
    });
  }
</script>
